import React from 'react'
import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  missingField: {
    color: theme.palette.error.main,
  },
}))

/**
 * Component for displaying fields in the overview. Displays missing required field in red
 * @param children
 * @param fieldName
 * @constructor
 */
const FieldDisplay: React.VFC<{ children: string; fieldName: string }> = ({ children, fieldName }) => {
  const { classes } = useStyles()
  if (children) {
    return <>{children}</>
  }

  return <span className={classes.missingField}>{fieldName}</span>
}

export default FieldDisplay
